import { Info } from '@mui/icons-material';
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';
import { environmentState, mainViewState } from '~/state/atoms/engineAtoms';
import { selectedROIState } from '~/state/atoms/structureSet/roiAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';

export default function InterpolationOperation() {
    const mainView = useRecoilValue(mainViewState);
    const environment = useRecoilValue(environmentState);
    const selectedROI = useRecoilValue(selectedROIState);
    const roi = environment?.structureSet?.getRoi(selectedROI);
    const structureApprovalStatus = roi?.dicomParent.approvalStatus;
    const currentStructureSet = useRecoilValue(currentStructureSetState);
    const selectedROIIndex = useRecoilValue(selectedROIState);

    const handleInterpolationCurrentSlice = () => {
        if (structureApprovalStatus === DICOMApprovalStatus.APPROVED) {
            enqueueSnackbar(
                'Interpolation is not allowed for this ROI as it has already been reviewed.',
                { variant: 'warning' }
            );
            return;
        }
        if (currentStructureSet && roi && mainView) {
            const planeCoordinates = mainView.position[2];
            environment?.handleInterpolateSingleSlice(roi, planeCoordinates);
        }
    };

    const handleInterpolationAllEmptySlices = () => {
        if (structureApprovalStatus === DICOMApprovalStatus.APPROVED) {
            enqueueSnackbar(
                'Interpolation is not allowed for this ROI as it has already been reviewed.',
                { variant: 'warning' }
            );
            return;
        }
        if (currentStructureSet && roi) {
            environment?.handleInterpolateAllSlices(roi);
        }
    };

    const isStructuresLoaded: undefined | boolean =
        currentStructureSet && selectedROIIndex >= 0;
    return (
        <Box>
            <Stack direction="row" spacing={1} alignItems="center" mb={2}>
                <Typography variant="h6">
                    <FormattedMessage id="interpolationTool" />
                </Typography>
                <Tooltip
                    title={<FormattedMessage id="interpolationToolGuide" />}
                >
                    <Info fontSize="small" />
                </Tooltip>
            </Stack>
            {isStructuresLoaded ? (
                <Box display="flex" flexDirection="column" gap={2}>
                    <Typography>
                        <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            disabled={!isStructuresLoaded}
                            onClick={handleInterpolationAllEmptySlices}
                        >
                            <FormattedMessage id="allEmptySlices" />
                        </Button>
                    </Typography>
                    <Typography>
                        <Button
                            variant="outlined"
                            color="primary"
                            fullWidth
                            disabled={!isStructuresLoaded}
                            onClick={handleInterpolationCurrentSlice}
                        >
                            <FormattedMessage id="currentSlice" />
                        </Button>
                    </Typography>
                </Box>
            ) : (
                <Typography>
                    <FormattedMessage id="pleaseSelectStructure" />
                </Typography>
            )}
        </Box>
    );
}
